import { BrowserRouter as Router } from "react-router-dom";
import { useRef } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home"; // Import Home.js
import "./App.css";

function App() {
  // Create refs for each section
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const portfolioRef = useRef(null);
  const contactRef = useRef(null);
  const productRef = useRef(null);
  const dataSecurityRef = useRef(null);

  // Scroll to the section
  const handleNavbarClick = (section) => {
    if (section === "about") {
      aboutRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (section === "services") {
      servicesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (section === "portfolio") {
      portfolioRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (section === "contact") {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (section === "product") {
      productRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (section === "dataSecurity") {
      dataSecurityRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Router>
      <div className="app">
        <Navbar handleNavbarClick={handleNavbarClick} /> {/* Pass handleNavbarClick */}
        <Home 
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          portfolioRef={portfolioRef}
          contactRef={contactRef}
          productRef={productRef}
          dataSecurityRef={dataSecurityRef}
        />
      </div>
    </Router>
  );
}

export default App;
